// AUTOGENERATED
import * as $runtime from "../runtime.js";
import * as Data$dGeneric$dRep from "../Data.Generic.Rep/index.js";
import * as Data$dList$dTypes from "../Data.List.Types/index.js";
import * as Data$dMaybe from "../Data.Maybe/index.js";
import * as Data$dShow$dGeneric from "../Data.Show.Generic/index.js";
import * as Foreign$dEncoding from "../Foreign.Encoding/index.js";
import * as Foreign$dGeneric$dClass from "../Foreign.Generic.Class/index.js";
import * as Restaumatic$dAnalytics$dTypes$dBeginCheckout from "../Restaumatic.Analytics.Types.BeginCheckout/index.js";
import * as Restaumatic$dAnalytics$dTypes$dChooseAddress from "../Restaumatic.Analytics.Types.ChooseAddress/index.js";
import * as Restaumatic$dAnalytics$dTypes$dChooseDate from "../Restaumatic.Analytics.Types.ChooseDate/index.js";
import * as Restaumatic$dAnalytics$dTypes$dChooseDelivery from "../Restaumatic.Analytics.Types.ChooseDelivery/index.js";
import * as Restaumatic$dAnalytics$dTypes$dChooseDineIn from "../Restaumatic.Analytics.Types.ChooseDineIn/index.js";
import * as Restaumatic$dAnalytics$dTypes$dChooseTakeaway from "../Restaumatic.Analytics.Types.ChooseTakeaway/index.js";
import * as Restaumatic$dAnalytics$dTypes$dExperienceImpression from "../Restaumatic.Analytics.Types.ExperienceImpression/index.js";
import * as Restaumatic$dAnalytics$dTypes$dFindAddress from "../Restaumatic.Analytics.Types.FindAddress/index.js";
import * as Restaumatic$dAnalytics$dTypes$dItem from "../Restaumatic.Analytics.Types.Item/index.js";
import * as Restaumatic$dAnalytics$dTypes$dNotOverlappingDishesLog from "../Restaumatic.Analytics.Types.NotOverlappingDishesLog/index.js";
import * as Restaumatic$dAnalytics$dTypes$dPage from "../Restaumatic.Analytics.Types.Page/index.js";
import * as Restaumatic$dAnalytics$dTypes$dPurchaseItem from "../Restaumatic.Analytics.Types.PurchaseItem/index.js";
import * as Restaumatic$dAnalytics$dTypes$dSetCheckoutOption from "../Restaumatic.Analytics.Types.SetCheckoutOption/index.js";
import * as Restaumatic$dAnalytics$dTypes$dSuggestionResult from "../Restaumatic.Analytics.Types.SuggestionResult/index.js";
import * as Restaumatic$dAnalytics$dTypes$dVisitPage from "../Restaumatic.Analytics.Types.VisitPage/index.js";
import * as Unscramble$dGeneric from "../Unscramble.Generic/index.js";
const $Event = (tag, _1) => ({tag, _1});
const AddToCartIsSymbol = {reflectSymbol: () => "AddToCart"};
const LocateMeIsSymbol = {reflectSymbol: () => "LocateMe"};
const RemoveFromCartIsSymbol = {reflectSymbol: () => "RemoveFromCart"};
const BeginCheckoutIsSymbol = {reflectSymbol: () => "BeginCheckout"};
const PurchaseIsSymbol = {reflectSymbol: () => "Purchase"};
const SetCheckoutOptionIsSymbol = {reflectSymbol: () => "SetCheckoutOption"};
const ExperienceImpressionIsSymbol = {reflectSymbol: () => "ExperienceImpression"};
const SuggestionResultIsSymbol = {reflectSymbol: () => "SuggestionResult"};
const NotOverlappingDishesIsSymbol = {reflectSymbol: () => "NotOverlappingDishes"};
const VisitPageIsSymbol = {reflectSymbol: () => "VisitPage"};
const ChooseDeliveryIsSymbol = {reflectSymbol: () => "ChooseDelivery"};
const ChooseTakeawayIsSymbol = {reflectSymbol: () => "ChooseTakeaway"};
const ChooseAddressIsSymbol = {reflectSymbol: () => "ChooseAddress"};
const ChooseDineInIsSymbol = {reflectSymbol: () => "ChooseDineIn"};
const ChooseDateIsSymbol = {reflectSymbol: () => "ChooseDate"};
const FindAddressIsSymbol = {reflectSymbol: () => "FindAddress"};
const ReviewGoogleLinkShownIsSymbol = {reflectSymbol: () => "ReviewGoogleLinkShown"};
const OrderingImpossibleAlertIsSymbol = {reflectSymbol: () => "OrderingImpossibleAlert"};
const decodeSingleConstructorAr1 = {unsafeDecodeSingleConstructorArgument: x => Restaumatic$dAnalytics$dTypes$dItem.unscrambleDecodeItem.unsafeDecode(x.contents)};
const genericEncodeArgsArgument = {
  encodeArgs: opts => v => Data$dList$dTypes.$List(
    "Cons",
    Foreign$dGeneric$dClass.$Arg("PlainArg", Restaumatic$dAnalytics$dTypes$dItem.encodeItem.encode(v)),
    Data$dList$dTypes.Nil
  )
};
const genericDecodeArgsArgument = {
  decodeArgs: /* #__PURE__ */ Foreign$dGeneric$dClass.decodeArgsArgument({decodeWithOptions: v => Restaumatic$dAnalytics$dTypes$dItem.decodeItem.decode}),
  decodeSingleRecordArg: Data$dMaybe.Nothing
};
const AddToCart = value0 => $Event("AddToCart", value0);
const LocateMe = /* #__PURE__ */ $Event("LocateMe");
const RemoveFromCart = value0 => $Event("RemoveFromCart", value0);
const BeginCheckout = value0 => $Event("BeginCheckout", value0);
const Purchase = value0 => $Event("Purchase", value0);
const SetCheckoutOption = value0 => $Event("SetCheckoutOption", value0);
const ExperienceImpression = value0 => $Event("ExperienceImpression", value0);
const SuggestionResult = value0 => $Event("SuggestionResult", value0);
const NotOverlappingDishes = value0 => $Event("NotOverlappingDishes", value0);
const VisitPage = value0 => $Event("VisitPage", value0);
const ChooseDelivery = value0 => $Event("ChooseDelivery", value0);
const ChooseTakeaway = value0 => $Event("ChooseTakeaway", value0);
const ChooseAddress = value0 => $Event("ChooseAddress", value0);
const ChooseDineIn = value0 => $Event("ChooseDineIn", value0);
const ChooseDate = value0 => $Event("ChooseDate", value0);
const FindAddress = value0 => $Event("FindAddress", value0);
const ReviewGoogleLinkShown = /* #__PURE__ */ $Event("ReviewGoogleLinkShown");
const OrderingImpossibleAlert = /* #__PURE__ */ $Event("OrderingImpossibleAlert");
const toFillFormTypeEvent = {fillFormDataType: v => "unknown"};
const eqEvent = {
  eq: x => y => {
    if (x.tag === "AddToCart") {
      if (y.tag === "AddToCart") { return Restaumatic$dAnalytics$dTypes$dItem.eqItem.eq(x._1)(y._1); }
      return false;
    }
    if (x.tag === "LocateMe") { return y.tag === "LocateMe"; }
    if (x.tag === "RemoveFromCart") {
      if (y.tag === "RemoveFromCart") { return Restaumatic$dAnalytics$dTypes$dItem.eqItem.eq(x._1)(y._1); }
      return false;
    }
    if (x.tag === "BeginCheckout") {
      if (y.tag === "BeginCheckout") { return Restaumatic$dAnalytics$dTypes$dBeginCheckout.eq(x._1.items)(y._1.items); }
      return false;
    }
    if (x.tag === "Purchase") {
      if (y.tag === "Purchase") { return Restaumatic$dAnalytics$dTypes$dPurchaseItem.eqPurchaseItem.eq(x._1)(y._1); }
      return false;
    }
    if (x.tag === "SetCheckoutOption") {
      if (y.tag === "SetCheckoutOption") { return x._1.selectedOption === y._1.selectedOption && x._1.selectedValue === y._1.selectedValue; }
      return false;
    }
    if (x.tag === "ExperienceImpression") {
      if (y.tag === "ExperienceImpression") { return x._1.experiment === y._1.experiment && x._1.variant === y._1.variant; }
      return false;
    }
    if (x.tag === "SuggestionResult") {
      if (y.tag === "SuggestionResult") { return Restaumatic$dAnalytics$dTypes$dSuggestionResult.eqSuggestionResult.eq(x._1)(y._1); }
      return false;
    }
    if (x.tag === "NotOverlappingDishes") {
      if (y.tag === "NotOverlappingDishes") { return x._1.action === y._1.action && x._1.category === y._1.category && x._1.label === y._1.label; }
      return false;
    }
    if (x.tag === "VisitPage") {
      if (y.tag === "VisitPage") { return Restaumatic$dAnalytics$dTypes$dPage.eqPage.eq(x._1.page)(y._1.page); }
      return false;
    }
    if (x.tag === "ChooseDelivery") {
      if (y.tag === "ChooseDelivery") { return Restaumatic$dAnalytics$dTypes$dPage.eqPage.eq(x._1.page)(y._1.page); }
      return false;
    }
    if (x.tag === "ChooseTakeaway") {
      if (y.tag === "ChooseTakeaway") { return Restaumatic$dAnalytics$dTypes$dPage.eqPage.eq(x._1.page)(y._1.page); }
      return false;
    }
    if (x.tag === "ChooseAddress") {
      if (y.tag === "ChooseAddress") { return Restaumatic$dAnalytics$dTypes$dPage.eqPage.eq(x._1.page)(y._1.page); }
      return false;
    }
    if (x.tag === "ChooseDineIn") {
      if (y.tag === "ChooseDineIn") { return Restaumatic$dAnalytics$dTypes$dPage.eqPage.eq(x._1.page)(y._1.page); }
      return false;
    }
    if (x.tag === "ChooseDate") {
      if (y.tag === "ChooseDate") { return Restaumatic$dAnalytics$dTypes$dPage.eqPage.eq(x._1.page)(y._1.page); }
      return false;
    }
    if (x.tag === "FindAddress") {
      if (y.tag === "FindAddress") { return Restaumatic$dAnalytics$dTypes$dFindAddress.eqFindAddress.eq(x._1)(y._1); }
      return false;
    }
    if (x.tag === "ReviewGoogleLinkShown") { return y.tag === "ReviewGoogleLinkShown"; }
    if (x.tag === "OrderingImpossibleAlert") { return y.tag === "OrderingImpossibleAlert"; }
    return false;
  }
};
const genericEvent = {
  to: x => {
    if (x.tag === "Inl") { return $Event("AddToCart", x._1); }
    if (x.tag === "Inr") {
      if (x._1.tag === "Inl") { return LocateMe; }
      if (x._1.tag === "Inr") {
        if (x._1._1.tag === "Inl") { return $Event("RemoveFromCart", x._1._1._1); }
        if (x._1._1.tag === "Inr") {
          if (x._1._1._1.tag === "Inl") { return $Event("BeginCheckout", x._1._1._1._1); }
          if (x._1._1._1.tag === "Inr") {
            if (x._1._1._1._1.tag === "Inl") { return $Event("Purchase", x._1._1._1._1._1); }
            if (x._1._1._1._1.tag === "Inr") {
              if (x._1._1._1._1._1.tag === "Inl") { return $Event("SetCheckoutOption", x._1._1._1._1._1._1); }
              if (x._1._1._1._1._1.tag === "Inr") {
                if (x._1._1._1._1._1._1.tag === "Inl") { return $Event("ExperienceImpression", x._1._1._1._1._1._1._1); }
                if (x._1._1._1._1._1._1.tag === "Inr") {
                  if (x._1._1._1._1._1._1._1.tag === "Inl") { return $Event("SuggestionResult", x._1._1._1._1._1._1._1._1); }
                  if (x._1._1._1._1._1._1._1.tag === "Inr") {
                    if (x._1._1._1._1._1._1._1._1.tag === "Inl") { return $Event("NotOverlappingDishes", x._1._1._1._1._1._1._1._1._1); }
                    if (x._1._1._1._1._1._1._1._1.tag === "Inr") {
                      if (x._1._1._1._1._1._1._1._1._1.tag === "Inl") { return $Event("VisitPage", x._1._1._1._1._1._1._1._1._1._1); }
                      if (x._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                        if (x._1._1._1._1._1._1._1._1._1._1.tag === "Inl") { return $Event("ChooseDelivery", x._1._1._1._1._1._1._1._1._1._1._1); }
                        if (x._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                          if (x._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") { return $Event("ChooseTakeaway", x._1._1._1._1._1._1._1._1._1._1._1._1); }
                          if (x._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                            if (x._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") { return $Event("ChooseAddress", x._1._1._1._1._1._1._1._1._1._1._1._1._1); }
                            if (x._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                              if (x._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") { return $Event("ChooseDineIn", x._1._1._1._1._1._1._1._1._1._1._1._1._1._1); }
                              if (x._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                                if (x._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") { return $Event("ChooseDate", x._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1); }
                                if (x._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                                  if (x._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") {
                                    return $Event("FindAddress", x._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1);
                                  }
                                  if (x._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                                    if (x._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") { return ReviewGoogleLinkShown; }
                                    if (x._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") { return OrderingImpossibleAlert; }
                                    $runtime.fail();
                                  }
                                  $runtime.fail();
                                }
                                $runtime.fail();
                              }
                              $runtime.fail();
                            }
                            $runtime.fail();
                          }
                          $runtime.fail();
                        }
                        $runtime.fail();
                      }
                      $runtime.fail();
                    }
                    $runtime.fail();
                  }
                  $runtime.fail();
                }
                $runtime.fail();
              }
              $runtime.fail();
            }
            $runtime.fail();
          }
          $runtime.fail();
        }
        $runtime.fail();
      }
      $runtime.fail();
    }
    $runtime.fail();
  },
  from: x => {
    if (x.tag === "AddToCart") { return Data$dGeneric$dRep.$Sum("Inl", x._1); }
    if (x.tag === "LocateMe") { return Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inl", Data$dGeneric$dRep.NoArguments)); }
    if (x.tag === "RemoveFromCart") { return Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inl", x._1))); }
    if (x.tag === "BeginCheckout") { return Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inl", x._1)))); }
    if (x.tag === "Purchase") {
      return Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inl", x._1)))));
    }
    if (x.tag === "SetCheckoutOption") {
      return Data$dGeneric$dRep.$Sum(
        "Inr",
        Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inl", x._1)))))
      );
    }
    if (x.tag === "ExperienceImpression") {
      return Data$dGeneric$dRep.$Sum(
        "Inr",
        Data$dGeneric$dRep.$Sum(
          "Inr",
          Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inl", x._1)))))
        )
      );
    }
    if (x.tag === "SuggestionResult") {
      return Data$dGeneric$dRep.$Sum(
        "Inr",
        Data$dGeneric$dRep.$Sum(
          "Inr",
          Data$dGeneric$dRep.$Sum(
            "Inr",
            Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inl", x._1)))))
          )
        )
      );
    }
    if (x.tag === "NotOverlappingDishes") {
      return Data$dGeneric$dRep.$Sum(
        "Inr",
        Data$dGeneric$dRep.$Sum(
          "Inr",
          Data$dGeneric$dRep.$Sum(
            "Inr",
            Data$dGeneric$dRep.$Sum(
              "Inr",
              Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inl", x._1)))))
            )
          )
        )
      );
    }
    if (x.tag === "VisitPage") {
      return Data$dGeneric$dRep.$Sum(
        "Inr",
        Data$dGeneric$dRep.$Sum(
          "Inr",
          Data$dGeneric$dRep.$Sum(
            "Inr",
            Data$dGeneric$dRep.$Sum(
              "Inr",
              Data$dGeneric$dRep.$Sum(
                "Inr",
                Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inl", x._1)))))
              )
            )
          )
        )
      );
    }
    if (x.tag === "ChooseDelivery") {
      return Data$dGeneric$dRep.$Sum(
        "Inr",
        Data$dGeneric$dRep.$Sum(
          "Inr",
          Data$dGeneric$dRep.$Sum(
            "Inr",
            Data$dGeneric$dRep.$Sum(
              "Inr",
              Data$dGeneric$dRep.$Sum(
                "Inr",
                Data$dGeneric$dRep.$Sum(
                  "Inr",
                  Data$dGeneric$dRep.$Sum(
                    "Inr",
                    Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inl", x._1))))
                  )
                )
              )
            )
          )
        )
      );
    }
    if (x.tag === "ChooseTakeaway") {
      return Data$dGeneric$dRep.$Sum(
        "Inr",
        Data$dGeneric$dRep.$Sum(
          "Inr",
          Data$dGeneric$dRep.$Sum(
            "Inr",
            Data$dGeneric$dRep.$Sum(
              "Inr",
              Data$dGeneric$dRep.$Sum(
                "Inr",
                Data$dGeneric$dRep.$Sum(
                  "Inr",
                  Data$dGeneric$dRep.$Sum(
                    "Inr",
                    Data$dGeneric$dRep.$Sum(
                      "Inr",
                      Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inl", x._1))))
                    )
                  )
                )
              )
            )
          )
        )
      );
    }
    if (x.tag === "ChooseAddress") {
      return Data$dGeneric$dRep.$Sum(
        "Inr",
        Data$dGeneric$dRep.$Sum(
          "Inr",
          Data$dGeneric$dRep.$Sum(
            "Inr",
            Data$dGeneric$dRep.$Sum(
              "Inr",
              Data$dGeneric$dRep.$Sum(
                "Inr",
                Data$dGeneric$dRep.$Sum(
                  "Inr",
                  Data$dGeneric$dRep.$Sum(
                    "Inr",
                    Data$dGeneric$dRep.$Sum(
                      "Inr",
                      Data$dGeneric$dRep.$Sum(
                        "Inr",
                        Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inl", x._1))))
                      )
                    )
                  )
                )
              )
            )
          )
        )
      );
    }
    if (x.tag === "ChooseDineIn") {
      return Data$dGeneric$dRep.$Sum(
        "Inr",
        Data$dGeneric$dRep.$Sum(
          "Inr",
          Data$dGeneric$dRep.$Sum(
            "Inr",
            Data$dGeneric$dRep.$Sum(
              "Inr",
              Data$dGeneric$dRep.$Sum(
                "Inr",
                Data$dGeneric$dRep.$Sum(
                  "Inr",
                  Data$dGeneric$dRep.$Sum(
                    "Inr",
                    Data$dGeneric$dRep.$Sum(
                      "Inr",
                      Data$dGeneric$dRep.$Sum(
                        "Inr",
                        Data$dGeneric$dRep.$Sum(
                          "Inr",
                          Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inl", x._1))))
                        )
                      )
                    )
                  )
                )
              )
            )
          )
        )
      );
    }
    if (x.tag === "ChooseDate") {
      return Data$dGeneric$dRep.$Sum(
        "Inr",
        Data$dGeneric$dRep.$Sum(
          "Inr",
          Data$dGeneric$dRep.$Sum(
            "Inr",
            Data$dGeneric$dRep.$Sum(
              "Inr",
              Data$dGeneric$dRep.$Sum(
                "Inr",
                Data$dGeneric$dRep.$Sum(
                  "Inr",
                  Data$dGeneric$dRep.$Sum(
                    "Inr",
                    Data$dGeneric$dRep.$Sum(
                      "Inr",
                      Data$dGeneric$dRep.$Sum(
                        "Inr",
                        Data$dGeneric$dRep.$Sum(
                          "Inr",
                          Data$dGeneric$dRep.$Sum(
                            "Inr",
                            Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inl", x._1))))
                          )
                        )
                      )
                    )
                  )
                )
              )
            )
          )
        )
      );
    }
    if (x.tag === "FindAddress") {
      return Data$dGeneric$dRep.$Sum(
        "Inr",
        Data$dGeneric$dRep.$Sum(
          "Inr",
          Data$dGeneric$dRep.$Sum(
            "Inr",
            Data$dGeneric$dRep.$Sum(
              "Inr",
              Data$dGeneric$dRep.$Sum(
                "Inr",
                Data$dGeneric$dRep.$Sum(
                  "Inr",
                  Data$dGeneric$dRep.$Sum(
                    "Inr",
                    Data$dGeneric$dRep.$Sum(
                      "Inr",
                      Data$dGeneric$dRep.$Sum(
                        "Inr",
                        Data$dGeneric$dRep.$Sum(
                          "Inr",
                          Data$dGeneric$dRep.$Sum(
                            "Inr",
                            Data$dGeneric$dRep.$Sum(
                              "Inr",
                              Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inl", x._1))))
                            )
                          )
                        )
                      )
                    )
                  )
                )
              )
            )
          )
        )
      );
    }
    if (x.tag === "ReviewGoogleLinkShown") {
      return Data$dGeneric$dRep.$Sum(
        "Inr",
        Data$dGeneric$dRep.$Sum(
          "Inr",
          Data$dGeneric$dRep.$Sum(
            "Inr",
            Data$dGeneric$dRep.$Sum(
              "Inr",
              Data$dGeneric$dRep.$Sum(
                "Inr",
                Data$dGeneric$dRep.$Sum(
                  "Inr",
                  Data$dGeneric$dRep.$Sum(
                    "Inr",
                    Data$dGeneric$dRep.$Sum(
                      "Inr",
                      Data$dGeneric$dRep.$Sum(
                        "Inr",
                        Data$dGeneric$dRep.$Sum(
                          "Inr",
                          Data$dGeneric$dRep.$Sum(
                            "Inr",
                            Data$dGeneric$dRep.$Sum(
                              "Inr",
                              Data$dGeneric$dRep.$Sum(
                                "Inr",
                                Data$dGeneric$dRep.$Sum(
                                  "Inr",
                                  Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inl", Data$dGeneric$dRep.NoArguments)))
                                )
                              )
                            )
                          )
                        )
                      )
                    )
                  )
                )
              )
            )
          )
        )
      );
    }
    if (x.tag === "OrderingImpossibleAlert") {
      return Data$dGeneric$dRep.$Sum(
        "Inr",
        Data$dGeneric$dRep.$Sum(
          "Inr",
          Data$dGeneric$dRep.$Sum(
            "Inr",
            Data$dGeneric$dRep.$Sum(
              "Inr",
              Data$dGeneric$dRep.$Sum(
                "Inr",
                Data$dGeneric$dRep.$Sum(
                  "Inr",
                  Data$dGeneric$dRep.$Sum(
                    "Inr",
                    Data$dGeneric$dRep.$Sum(
                      "Inr",
                      Data$dGeneric$dRep.$Sum(
                        "Inr",
                        Data$dGeneric$dRep.$Sum(
                          "Inr",
                          Data$dGeneric$dRep.$Sum(
                            "Inr",
                            Data$dGeneric$dRep.$Sum(
                              "Inr",
                              Data$dGeneric$dRep.$Sum(
                                "Inr",
                                Data$dGeneric$dRep.$Sum(
                                  "Inr",
                                  Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.NoArguments)))
                                )
                              )
                            )
                          )
                        )
                      )
                    )
                  )
                )
              )
            )
          )
        )
      );
    }
    $runtime.fail();
  }
};
const showEvent = {
  show: /* #__PURE__ */ (() => {
    const $0 = Data$dShow$dGeneric.genericShowConstructor({genericShowArgs: v => [Restaumatic$dAnalytics$dTypes$dItem.showItem.show(v)]})(AddToCartIsSymbol);
    const $1 = Data$dShow$dGeneric.genericShowConstructor(Data$dShow$dGeneric.genericShowArgsNoArguments)(LocateMeIsSymbol);
    const $2 = Data$dShow$dGeneric.genericShowConstructor({genericShowArgs: v => [Restaumatic$dAnalytics$dTypes$dItem.showItem.show(v)]})(RemoveFromCartIsSymbol);
    const $3 = Data$dShow$dGeneric.genericShowConstructor({genericShowArgs: v => [Restaumatic$dAnalytics$dTypes$dBeginCheckout.showBeginCheckout.show(v)]})(BeginCheckoutIsSymbol);
    const $4 = Data$dShow$dGeneric.genericShowConstructor({genericShowArgs: v => [Restaumatic$dAnalytics$dTypes$dPurchaseItem.showPurchaseItem.show(v)]})(PurchaseIsSymbol);
    const $5 = Data$dShow$dGeneric.genericShowConstructor({genericShowArgs: v => [Restaumatic$dAnalytics$dTypes$dSetCheckoutOption.showSetCheckoutOption.show(v)]})(SetCheckoutOptionIsSymbol);
    const $6 = Data$dShow$dGeneric.genericShowConstructor({genericShowArgs: v => [Restaumatic$dAnalytics$dTypes$dExperienceImpression.showExperienceImpression.show(v)]})(ExperienceImpressionIsSymbol);
    const $7 = Data$dShow$dGeneric.genericShowConstructor({genericShowArgs: v => [Restaumatic$dAnalytics$dTypes$dSuggestionResult.showSuggestionResult.show(v)]})(SuggestionResultIsSymbol);
    const $8 = Data$dShow$dGeneric.genericShowConstructor({genericShowArgs: v => [Restaumatic$dAnalytics$dTypes$dNotOverlappingDishesLog.showNotOverlappingDishesLog.show(v)]})(NotOverlappingDishesIsSymbol);
    const $9 = Data$dShow$dGeneric.genericShowConstructor({genericShowArgs: v => [Restaumatic$dAnalytics$dTypes$dVisitPage.showVisitPage.show(v)]})(VisitPageIsSymbol);
    const $10 = Data$dShow$dGeneric.genericShowConstructor({genericShowArgs: v => [Restaumatic$dAnalytics$dTypes$dChooseDelivery.showChooseDelivery.show(v)]})(ChooseDeliveryIsSymbol);
    const $11 = Data$dShow$dGeneric.genericShowConstructor({genericShowArgs: v => [Restaumatic$dAnalytics$dTypes$dChooseTakeaway.showChooseTakeaway.show(v)]})(ChooseTakeawayIsSymbol);
    const $12 = Data$dShow$dGeneric.genericShowConstructor({genericShowArgs: v => [Restaumatic$dAnalytics$dTypes$dChooseAddress.showChooseAddress.show(v)]})(ChooseAddressIsSymbol);
    const $13 = Data$dShow$dGeneric.genericShowConstructor({genericShowArgs: v => [Restaumatic$dAnalytics$dTypes$dChooseDineIn.showChooseDineIn.show(v)]})(ChooseDineInIsSymbol);
    const $14 = Data$dShow$dGeneric.genericShowConstructor({genericShowArgs: v => [Restaumatic$dAnalytics$dTypes$dChooseDate.showChooseDate.show(v)]})(ChooseDateIsSymbol);
    const $15 = Data$dShow$dGeneric.genericShowConstructor({genericShowArgs: v => [Restaumatic$dAnalytics$dTypes$dFindAddress.showFindAddress.show(v)]})(FindAddressIsSymbol);
    const $16 = Data$dShow$dGeneric.genericShowConstructor(Data$dShow$dGeneric.genericShowArgsNoArguments)(ReviewGoogleLinkShownIsSymbol);
    const $17 = Data$dShow$dGeneric.genericShowConstructor(Data$dShow$dGeneric.genericShowArgsNoArguments)(OrderingImpossibleAlertIsSymbol);
    return x => {
      const $18 = genericEvent.from(x);
      if ($18.tag === "Inl") { return $0["genericShow'"]($18._1); }
      if ($18.tag === "Inr") {
        if ($18._1.tag === "Inl") { return $1["genericShow'"]($18._1._1); }
        if ($18._1.tag === "Inr") {
          if ($18._1._1.tag === "Inl") { return $2["genericShow'"]($18._1._1._1); }
          if ($18._1._1.tag === "Inr") {
            if ($18._1._1._1.tag === "Inl") { return $3["genericShow'"]($18._1._1._1._1); }
            if ($18._1._1._1.tag === "Inr") {
              if ($18._1._1._1._1.tag === "Inl") { return $4["genericShow'"]($18._1._1._1._1._1); }
              if ($18._1._1._1._1.tag === "Inr") {
                if ($18._1._1._1._1._1.tag === "Inl") { return $5["genericShow'"]($18._1._1._1._1._1._1); }
                if ($18._1._1._1._1._1.tag === "Inr") {
                  if ($18._1._1._1._1._1._1.tag === "Inl") { return $6["genericShow'"]($18._1._1._1._1._1._1._1); }
                  if ($18._1._1._1._1._1._1.tag === "Inr") {
                    if ($18._1._1._1._1._1._1._1.tag === "Inl") { return $7["genericShow'"]($18._1._1._1._1._1._1._1._1); }
                    if ($18._1._1._1._1._1._1._1.tag === "Inr") {
                      if ($18._1._1._1._1._1._1._1._1.tag === "Inl") { return $8["genericShow'"]($18._1._1._1._1._1._1._1._1._1); }
                      if ($18._1._1._1._1._1._1._1._1.tag === "Inr") {
                        if ($18._1._1._1._1._1._1._1._1._1.tag === "Inl") { return $9["genericShow'"]($18._1._1._1._1._1._1._1._1._1._1); }
                        if ($18._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                          if ($18._1._1._1._1._1._1._1._1._1._1.tag === "Inl") { return $10["genericShow'"]($18._1._1._1._1._1._1._1._1._1._1._1); }
                          if ($18._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                            if ($18._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") { return $11["genericShow'"]($18._1._1._1._1._1._1._1._1._1._1._1._1); }
                            if ($18._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                              if ($18._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") { return $12["genericShow'"]($18._1._1._1._1._1._1._1._1._1._1._1._1._1); }
                              if ($18._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                                if ($18._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") { return $13["genericShow'"]($18._1._1._1._1._1._1._1._1._1._1._1._1._1._1); }
                                if ($18._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                                  if ($18._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") { return $14["genericShow'"]($18._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1); }
                                  if ($18._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                                    if ($18._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") {
                                      return $15["genericShow'"]($18._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1);
                                    }
                                    if ($18._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                                      if ($18._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") {
                                        return $16["genericShow'"]($18._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1);
                                      }
                                      if ($18._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                                        return $17["genericShow'"]($18._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1);
                                      }
                                      $runtime.fail();
                                    }
                                    $runtime.fail();
                                  }
                                  $runtime.fail();
                                }
                                $runtime.fail();
                              }
                              $runtime.fail();
                            }
                            $runtime.fail();
                          }
                          $runtime.fail();
                        }
                        $runtime.fail();
                      }
                      $runtime.fail();
                    }
                    $runtime.fail();
                  }
                  $runtime.fail();
                }
                $runtime.fail();
              }
              $runtime.fail();
            }
            $runtime.fail();
          }
          $runtime.fail();
        }
        $runtime.fail();
      }
      $runtime.fail();
    };
  })()
};
const unscrambleDecodeEvent = {
  unsafeDecode: /* #__PURE__ */ (() => {
    const $0 = Unscramble$dGeneric.genericDecodeTaggedSumType(Unscramble$dGeneric.genericDecodeSumSum(Unscramble$dGeneric.genericDecodeSumConstruct(AddToCartIsSymbol)(decodeSingleConstructorAr1))(Unscramble$dGeneric.genericDecodeSumSum(Unscramble$dGeneric.genericDecodeSumConstruct1(Unscramble$dGeneric.genericDecodeArgsNoArgume)(LocateMeIsSymbol))(Unscramble$dGeneric.genericDecodeSumSum(Unscramble$dGeneric.genericDecodeSumConstruct(RemoveFromCartIsSymbol)(decodeSingleConstructorAr1))(Unscramble$dGeneric.genericDecodeSumSum(Unscramble$dGeneric.genericDecodeSumConstruct(BeginCheckoutIsSymbol)({
      unsafeDecodeSingleConstructorArgument: x => Restaumatic$dAnalytics$dTypes$dBeginCheckout.unscrambleDecodeBeginCheckout.unsafeDecode(x.contents)
    }))(Unscramble$dGeneric.genericDecodeSumSum(Unscramble$dGeneric.genericDecodeSumConstruct(PurchaseIsSymbol)({
      unsafeDecodeSingleConstructorArgument: x => Restaumatic$dAnalytics$dTypes$dPurchaseItem.unscrambleDecodePurchaseItem.unsafeDecode(x.contents)
    }))(Unscramble$dGeneric.genericDecodeSumSum(Unscramble$dGeneric.genericDecodeSumConstruct(SetCheckoutOptionIsSymbol)({
      unsafeDecodeSingleConstructorArgument: x => Restaumatic$dAnalytics$dTypes$dSetCheckoutOption.unscrambleDecodeSetCheckoutOption.unsafeDecode(x.contents)
    }))(Unscramble$dGeneric.genericDecodeSumSum(Unscramble$dGeneric.genericDecodeSumConstruct(ExperienceImpressionIsSymbol)({
      unsafeDecodeSingleConstructorArgument: x => Restaumatic$dAnalytics$dTypes$dExperienceImpression.unscrambleDecodeExperienceImpression.unsafeDecode(x.contents)
    }))(Unscramble$dGeneric.genericDecodeSumSum(Unscramble$dGeneric.genericDecodeSumConstruct(SuggestionResultIsSymbol)({
      unsafeDecodeSingleConstructorArgument: x => Restaumatic$dAnalytics$dTypes$dSuggestionResult.unscrambleDecodeSuggestionResult.unsafeDecode(x.contents)
    }))(Unscramble$dGeneric.genericDecodeSumSum(Unscramble$dGeneric.genericDecodeSumConstruct(NotOverlappingDishesIsSymbol)({
      unsafeDecodeSingleConstructorArgument: x => Restaumatic$dAnalytics$dTypes$dNotOverlappingDishesLog.unscrambleDecodeNotOverlappingDishesLog.unsafeDecode(x.contents)
    }))(Unscramble$dGeneric.genericDecodeSumSum(Unscramble$dGeneric.genericDecodeSumConstruct(VisitPageIsSymbol)({
      unsafeDecodeSingleConstructorArgument: x => Restaumatic$dAnalytics$dTypes$dVisitPage.unscrambleDecodeVisitPage.unsafeDecode(x.contents)
    }))(Unscramble$dGeneric.genericDecodeSumSum(Unscramble$dGeneric.genericDecodeSumConstruct(ChooseDeliveryIsSymbol)({
      unsafeDecodeSingleConstructorArgument: x => Restaumatic$dAnalytics$dTypes$dChooseDelivery.unscrambleDecodeChooseDelivery.unsafeDecode(x.contents)
    }))(Unscramble$dGeneric.genericDecodeSumSum(Unscramble$dGeneric.genericDecodeSumConstruct(ChooseTakeawayIsSymbol)({
      unsafeDecodeSingleConstructorArgument: x => Restaumatic$dAnalytics$dTypes$dChooseTakeaway.unscrambleDecodeChooseTakeaway.unsafeDecode(x.contents)
    }))(Unscramble$dGeneric.genericDecodeSumSum(Unscramble$dGeneric.genericDecodeSumConstruct(ChooseAddressIsSymbol)({
      unsafeDecodeSingleConstructorArgument: x => Restaumatic$dAnalytics$dTypes$dChooseAddress.unscrambleDecodeChooseAddress.unsafeDecode(x.contents)
    }))(Unscramble$dGeneric.genericDecodeSumSum(Unscramble$dGeneric.genericDecodeSumConstruct(ChooseDineInIsSymbol)({
      unsafeDecodeSingleConstructorArgument: x => Restaumatic$dAnalytics$dTypes$dChooseDineIn.unscrambleDecodeChooseDineIn.unsafeDecode(x.contents)
    }))(Unscramble$dGeneric.genericDecodeSumSum(Unscramble$dGeneric.genericDecodeSumConstruct(ChooseDateIsSymbol)({
      unsafeDecodeSingleConstructorArgument: x => Restaumatic$dAnalytics$dTypes$dChooseDate.unscrambleDecodeChooseDate.unsafeDecode(x.contents)
    }))(Unscramble$dGeneric.genericDecodeSumSum(Unscramble$dGeneric.genericDecodeSumConstruct(FindAddressIsSymbol)({
      unsafeDecodeSingleConstructorArgument: x => Restaumatic$dAnalytics$dTypes$dFindAddress.unscrambleDecodeFindAddress.unsafeDecode(x.contents)
    }))(Unscramble$dGeneric.genericDecodeSumSum(Unscramble$dGeneric.genericDecodeSumConstruct1(Unscramble$dGeneric.genericDecodeArgsNoArgume)(ReviewGoogleLinkShownIsSymbol))(Unscramble$dGeneric.genericDecodeSumConstruct1(Unscramble$dGeneric.genericDecodeArgsNoArgume)(OrderingImpossibleAlertIsSymbol)))))))))))))))))))(Unscramble$dGeneric.defaultOptions);
    return x => genericEvent.to($0(x));
  })()
};
const encodeEvent = {
  encode: /* #__PURE__ */ Foreign$dEncoding.defaultEncode(genericEvent)(/* #__PURE__ */ (() => {
    const $0 = Foreign$dGeneric$dClass.genericEncodeConstructor(AddToCartIsSymbol)(genericEncodeArgsArgument);
    const $1 = Foreign$dGeneric$dClass.genericEncodeConstructor(LocateMeIsSymbol)(Foreign$dGeneric$dClass.genericEncodeArgsNoArguments);
    const $2 = Foreign$dGeneric$dClass.genericEncodeConstructor(RemoveFromCartIsSymbol)(genericEncodeArgsArgument);
    const $3 = Foreign$dGeneric$dClass.genericEncodeConstructor(BeginCheckoutIsSymbol)({
      encodeArgs: opts => v => Data$dList$dTypes.$List(
        "Cons",
        Foreign$dGeneric$dClass.$Arg("PlainArg", Restaumatic$dAnalytics$dTypes$dBeginCheckout.encodeBeginCheckout.encode(v)),
        Data$dList$dTypes.Nil
      )
    });
    const $4 = Foreign$dGeneric$dClass.genericEncodeConstructor(PurchaseIsSymbol)({
      encodeArgs: opts => v => Data$dList$dTypes.$List(
        "Cons",
        Foreign$dGeneric$dClass.$Arg("PlainArg", Restaumatic$dAnalytics$dTypes$dPurchaseItem.encodePurchaseItem.encode(v)),
        Data$dList$dTypes.Nil
      )
    });
    const $5 = Foreign$dGeneric$dClass.genericEncodeConstructor(SetCheckoutOptionIsSymbol)({
      encodeArgs: opts => v => Data$dList$dTypes.$List(
        "Cons",
        Foreign$dGeneric$dClass.$Arg("PlainArg", Restaumatic$dAnalytics$dTypes$dSetCheckoutOption.encodeSetCheckoutOption.encode(v)),
        Data$dList$dTypes.Nil
      )
    });
    const $6 = Foreign$dGeneric$dClass.genericEncodeConstructor(ExperienceImpressionIsSymbol)({
      encodeArgs: opts => v => Data$dList$dTypes.$List(
        "Cons",
        Foreign$dGeneric$dClass.$Arg("PlainArg", Restaumatic$dAnalytics$dTypes$dExperienceImpression.encodeExperienceImpression.encode(v)),
        Data$dList$dTypes.Nil
      )
    });
    const $7 = Foreign$dGeneric$dClass.genericEncodeConstructor(SuggestionResultIsSymbol)({
      encodeArgs: opts => v => Data$dList$dTypes.$List(
        "Cons",
        Foreign$dGeneric$dClass.$Arg("PlainArg", Restaumatic$dAnalytics$dTypes$dSuggestionResult.encodeSuggestionResult.encode(v)),
        Data$dList$dTypes.Nil
      )
    });
    const $8 = Foreign$dGeneric$dClass.genericEncodeConstructor(NotOverlappingDishesIsSymbol)({
      encodeArgs: opts => v => Data$dList$dTypes.$List(
        "Cons",
        Foreign$dGeneric$dClass.$Arg("PlainArg", Restaumatic$dAnalytics$dTypes$dNotOverlappingDishesLog.encodeNotOverlappingDishesLog.encode(v)),
        Data$dList$dTypes.Nil
      )
    });
    const $9 = Foreign$dGeneric$dClass.genericEncodeConstructor(VisitPageIsSymbol)({
      encodeArgs: opts => v => Data$dList$dTypes.$List(
        "Cons",
        Foreign$dGeneric$dClass.$Arg("PlainArg", Restaumatic$dAnalytics$dTypes$dVisitPage.encodeVisitPage.encode(v)),
        Data$dList$dTypes.Nil
      )
    });
    const $10 = Foreign$dGeneric$dClass.genericEncodeConstructor(ChooseDeliveryIsSymbol)({
      encodeArgs: opts => v => Data$dList$dTypes.$List(
        "Cons",
        Foreign$dGeneric$dClass.$Arg("PlainArg", Restaumatic$dAnalytics$dTypes$dChooseDelivery.encodeChooseDelivery.encode(v)),
        Data$dList$dTypes.Nil
      )
    });
    const $11 = Foreign$dGeneric$dClass.genericEncodeConstructor(ChooseTakeawayIsSymbol)({
      encodeArgs: opts => v => Data$dList$dTypes.$List(
        "Cons",
        Foreign$dGeneric$dClass.$Arg("PlainArg", Restaumatic$dAnalytics$dTypes$dChooseTakeaway.encodeChooseTakeaway.encode(v)),
        Data$dList$dTypes.Nil
      )
    });
    const $12 = Foreign$dGeneric$dClass.genericEncodeConstructor(ChooseAddressIsSymbol)({
      encodeArgs: opts => v => Data$dList$dTypes.$List(
        "Cons",
        Foreign$dGeneric$dClass.$Arg("PlainArg", Restaumatic$dAnalytics$dTypes$dChooseAddress.encodeChooseAddress.encode(v)),
        Data$dList$dTypes.Nil
      )
    });
    const $13 = Foreign$dGeneric$dClass.genericEncodeConstructor(ChooseDineInIsSymbol)({
      encodeArgs: opts => v => Data$dList$dTypes.$List(
        "Cons",
        Foreign$dGeneric$dClass.$Arg("PlainArg", Restaumatic$dAnalytics$dTypes$dChooseDineIn.encodeChooseDineIn.encode(v)),
        Data$dList$dTypes.Nil
      )
    });
    const $14 = Foreign$dGeneric$dClass.genericEncodeConstructor(ChooseDateIsSymbol)({
      encodeArgs: opts => v => Data$dList$dTypes.$List(
        "Cons",
        Foreign$dGeneric$dClass.$Arg("PlainArg", Restaumatic$dAnalytics$dTypes$dChooseDate.encodeChooseDate.encode(v)),
        Data$dList$dTypes.Nil
      )
    });
    const $15 = Foreign$dGeneric$dClass.genericEncodeConstructor(FindAddressIsSymbol)({
      encodeArgs: opts => v => Data$dList$dTypes.$List(
        "Cons",
        Foreign$dGeneric$dClass.$Arg("PlainArg", Restaumatic$dAnalytics$dTypes$dFindAddress.encodeFindAddress.encode(v)),
        Data$dList$dTypes.Nil
      )
    });
    const $16 = Foreign$dGeneric$dClass.genericEncodeConstructor(ReviewGoogleLinkShownIsSymbol)(Foreign$dGeneric$dClass.genericEncodeArgsNoArguments);
    const $17 = Foreign$dGeneric$dClass.genericEncodeConstructor(OrderingImpossibleAlertIsSymbol)(Foreign$dGeneric$dClass.genericEncodeArgsNoArguments);
    return {
      encodeOpts: v => v1 => {
        if (v1.tag === "Inl") { return $0.encodeOpts({...v, unwrapSingleConstructors: false})(v1._1); }
        if (v1.tag === "Inr") {
          if (v1._1.tag === "Inl") { return $1.encodeOpts({...v, unwrapSingleConstructors: false})(v1._1._1); }
          if (v1._1.tag === "Inr") {
            if (v1._1._1.tag === "Inl") { return $2.encodeOpts({...v, unwrapSingleConstructors: false})(v1._1._1._1); }
            if (v1._1._1.tag === "Inr") {
              if (v1._1._1._1.tag === "Inl") { return $3.encodeOpts({...v, unwrapSingleConstructors: false})(v1._1._1._1._1); }
              if (v1._1._1._1.tag === "Inr") {
                if (v1._1._1._1._1.tag === "Inl") { return $4.encodeOpts({...v, unwrapSingleConstructors: false})(v1._1._1._1._1._1); }
                if (v1._1._1._1._1.tag === "Inr") {
                  if (v1._1._1._1._1._1.tag === "Inl") { return $5.encodeOpts({...v, unwrapSingleConstructors: false})(v1._1._1._1._1._1._1); }
                  if (v1._1._1._1._1._1.tag === "Inr") {
                    if (v1._1._1._1._1._1._1.tag === "Inl") { return $6.encodeOpts({...v, unwrapSingleConstructors: false})(v1._1._1._1._1._1._1._1); }
                    if (v1._1._1._1._1._1._1.tag === "Inr") {
                      if (v1._1._1._1._1._1._1._1.tag === "Inl") { return $7.encodeOpts({...v, unwrapSingleConstructors: false})(v1._1._1._1._1._1._1._1._1); }
                      if (v1._1._1._1._1._1._1._1.tag === "Inr") {
                        if (v1._1._1._1._1._1._1._1._1.tag === "Inl") { return $8.encodeOpts({...v, unwrapSingleConstructors: false})(v1._1._1._1._1._1._1._1._1._1); }
                        if (v1._1._1._1._1._1._1._1._1.tag === "Inr") {
                          if (v1._1._1._1._1._1._1._1._1._1.tag === "Inl") { return $9.encodeOpts({...v, unwrapSingleConstructors: false})(v1._1._1._1._1._1._1._1._1._1._1); }
                          if (v1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                            if (v1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") {
                              return $10.encodeOpts({...v, unwrapSingleConstructors: false})(v1._1._1._1._1._1._1._1._1._1._1._1);
                            }
                            if (v1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                              if (v1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") {
                                return $11.encodeOpts({...v, unwrapSingleConstructors: false})(v1._1._1._1._1._1._1._1._1._1._1._1._1);
                              }
                              if (v1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                                if (v1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") {
                                  return $12.encodeOpts({...v, unwrapSingleConstructors: false})(v1._1._1._1._1._1._1._1._1._1._1._1._1._1);
                                }
                                if (v1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                                  if (v1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") {
                                    return $13.encodeOpts({...v, unwrapSingleConstructors: false})(v1._1._1._1._1._1._1._1._1._1._1._1._1._1._1);
                                  }
                                  if (v1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                                    if (v1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") {
                                      return $14.encodeOpts({...v, unwrapSingleConstructors: false})(v1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1);
                                    }
                                    if (v1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                                      if (v1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") {
                                        return $15.encodeOpts({...v, unwrapSingleConstructors: false})(v1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1);
                                      }
                                      if (v1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                                        if (v1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inl") {
                                          return $16.encodeOpts({...v, unwrapSingleConstructors: false})(v1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1);
                                        }
                                        if (v1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1.tag === "Inr") {
                                          return $17.encodeOpts({...v, unwrapSingleConstructors: false})(v1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1._1);
                                        }
                                        $runtime.fail();
                                      }
                                      $runtime.fail();
                                    }
                                    $runtime.fail();
                                  }
                                  $runtime.fail();
                                }
                                $runtime.fail();
                              }
                              $runtime.fail();
                            }
                            $runtime.fail();
                          }
                          $runtime.fail();
                        }
                        $runtime.fail();
                      }
                      $runtime.fail();
                    }
                    $runtime.fail();
                  }
                  $runtime.fail();
                }
                $runtime.fail();
              }
              $runtime.fail();
            }
            $runtime.fail();
          }
          $runtime.fail();
        }
        $runtime.fail();
      }
    };
  })())
};
const decodeEvent = {
  decode: /* #__PURE__ */ Foreign$dEncoding.defaultDecode(genericEvent)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeSum(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor(AddToCartIsSymbol)(genericDecodeArgsArgument)(Foreign$dGeneric$dClass.genericCountArgsArgument))(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeSum(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor(LocateMeIsSymbol)(Foreign$dGeneric$dClass.genericDecodeArgsNoArguments)(Foreign$dGeneric$dClass.genericCountArgsNoArguments))(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeSum(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor(RemoveFromCartIsSymbol)(genericDecodeArgsArgument)(Foreign$dGeneric$dClass.genericCountArgsArgument))(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeSum(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor(BeginCheckoutIsSymbol)({
    decodeArgs: /* #__PURE__ */ Foreign$dGeneric$dClass.decodeArgsArgument({decodeWithOptions: v => Restaumatic$dAnalytics$dTypes$dBeginCheckout.decodeBeginCheckout.decode}),
    decodeSingleRecordArg: Data$dMaybe.Nothing
  })(Foreign$dGeneric$dClass.genericCountArgsArgument))(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeSum(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor(PurchaseIsSymbol)({
    decodeArgs: /* #__PURE__ */ Foreign$dGeneric$dClass.decodeArgsArgument({decodeWithOptions: v => Restaumatic$dAnalytics$dTypes$dPurchaseItem.decodePurchaseItem.decode}),
    decodeSingleRecordArg: Data$dMaybe.Nothing
  })(Foreign$dGeneric$dClass.genericCountArgsArgument))(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeSum(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor(SetCheckoutOptionIsSymbol)({
    decodeArgs: /* #__PURE__ */ Foreign$dGeneric$dClass.decodeArgsArgument({decodeWithOptions: v => Restaumatic$dAnalytics$dTypes$dSetCheckoutOption.decodeSetCheckoutOption.decode}),
    decodeSingleRecordArg: Data$dMaybe.Nothing
  })(Foreign$dGeneric$dClass.genericCountArgsArgument))(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeSum(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor(ExperienceImpressionIsSymbol)({
    decodeArgs: /* #__PURE__ */ Foreign$dGeneric$dClass.decodeArgsArgument({
      decodeWithOptions: v => Restaumatic$dAnalytics$dTypes$dExperienceImpression.decodeExperienceImpression.decode
    }),
    decodeSingleRecordArg: Data$dMaybe.Nothing
  })(Foreign$dGeneric$dClass.genericCountArgsArgument))(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeSum(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor(SuggestionResultIsSymbol)({
    decodeArgs: /* #__PURE__ */ Foreign$dGeneric$dClass.decodeArgsArgument({decodeWithOptions: v => Restaumatic$dAnalytics$dTypes$dSuggestionResult.decodeSuggestionResult.decode}),
    decodeSingleRecordArg: Data$dMaybe.Nothing
  })(Foreign$dGeneric$dClass.genericCountArgsArgument))(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeSum(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor(NotOverlappingDishesIsSymbol)({
    decodeArgs: /* #__PURE__ */ Foreign$dGeneric$dClass.decodeArgsArgument({
      decodeWithOptions: v => Restaumatic$dAnalytics$dTypes$dNotOverlappingDishesLog.decodeNotOverlappingDishesLog.decode
    }),
    decodeSingleRecordArg: Data$dMaybe.Nothing
  })(Foreign$dGeneric$dClass.genericCountArgsArgument))(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeSum(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor(VisitPageIsSymbol)({
    decodeArgs: /* #__PURE__ */ Foreign$dGeneric$dClass.decodeArgsArgument({decodeWithOptions: v => Restaumatic$dAnalytics$dTypes$dVisitPage.decodeVisitPage.decode}),
    decodeSingleRecordArg: Data$dMaybe.Nothing
  })(Foreign$dGeneric$dClass.genericCountArgsArgument))(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeSum(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor(ChooseDeliveryIsSymbol)({
    decodeArgs: /* #__PURE__ */ Foreign$dGeneric$dClass.decodeArgsArgument({decodeWithOptions: v => Restaumatic$dAnalytics$dTypes$dChooseDelivery.decodeChooseDelivery.decode}),
    decodeSingleRecordArg: Data$dMaybe.Nothing
  })(Foreign$dGeneric$dClass.genericCountArgsArgument))(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeSum(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor(ChooseTakeawayIsSymbol)({
    decodeArgs: /* #__PURE__ */ Foreign$dGeneric$dClass.decodeArgsArgument({decodeWithOptions: v => Restaumatic$dAnalytics$dTypes$dChooseTakeaway.decodeChooseTakeaway.decode}),
    decodeSingleRecordArg: Data$dMaybe.Nothing
  })(Foreign$dGeneric$dClass.genericCountArgsArgument))(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeSum(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor(ChooseAddressIsSymbol)({
    decodeArgs: /* #__PURE__ */ Foreign$dGeneric$dClass.decodeArgsArgument({decodeWithOptions: v => Restaumatic$dAnalytics$dTypes$dChooseAddress.decodeChooseAddress.decode}),
    decodeSingleRecordArg: Data$dMaybe.Nothing
  })(Foreign$dGeneric$dClass.genericCountArgsArgument))(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeSum(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor(ChooseDineInIsSymbol)({
    decodeArgs: /* #__PURE__ */ Foreign$dGeneric$dClass.decodeArgsArgument({decodeWithOptions: v => Restaumatic$dAnalytics$dTypes$dChooseDineIn.decodeChooseDineIn.decode}),
    decodeSingleRecordArg: Data$dMaybe.Nothing
  })(Foreign$dGeneric$dClass.genericCountArgsArgument))(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeSum(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor(ChooseDateIsSymbol)({
    decodeArgs: /* #__PURE__ */ Foreign$dGeneric$dClass.decodeArgsArgument({decodeWithOptions: v => Restaumatic$dAnalytics$dTypes$dChooseDate.decodeChooseDate.decode}),
    decodeSingleRecordArg: Data$dMaybe.Nothing
  })(Foreign$dGeneric$dClass.genericCountArgsArgument))(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeSum(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor(FindAddressIsSymbol)({
    decodeArgs: /* #__PURE__ */ Foreign$dGeneric$dClass.decodeArgsArgument({decodeWithOptions: v => Restaumatic$dAnalytics$dTypes$dFindAddress.decodeFindAddress.decode}),
    decodeSingleRecordArg: Data$dMaybe.Nothing
  })(Foreign$dGeneric$dClass.genericCountArgsArgument))(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeSum(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor(ReviewGoogleLinkShownIsSymbol)(Foreign$dGeneric$dClass.genericDecodeArgsNoArguments)(Foreign$dGeneric$dClass.genericCountArgsNoArguments))(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor(OrderingImpossibleAlertIsSymbol)(Foreign$dGeneric$dClass.genericDecodeArgsNoArguments)(Foreign$dGeneric$dClass.genericCountArgsNoArguments)))))))))))))))))))
};
export {
  $Event,
  AddToCart,
  AddToCartIsSymbol,
  BeginCheckout,
  BeginCheckoutIsSymbol,
  ChooseAddress,
  ChooseAddressIsSymbol,
  ChooseDate,
  ChooseDateIsSymbol,
  ChooseDelivery,
  ChooseDeliveryIsSymbol,
  ChooseDineIn,
  ChooseDineInIsSymbol,
  ChooseTakeaway,
  ChooseTakeawayIsSymbol,
  ExperienceImpression,
  ExperienceImpressionIsSymbol,
  FindAddress,
  FindAddressIsSymbol,
  LocateMe,
  LocateMeIsSymbol,
  NotOverlappingDishes,
  NotOverlappingDishesIsSymbol,
  OrderingImpossibleAlert,
  OrderingImpossibleAlertIsSymbol,
  Purchase,
  PurchaseIsSymbol,
  RemoveFromCart,
  RemoveFromCartIsSymbol,
  ReviewGoogleLinkShown,
  ReviewGoogleLinkShownIsSymbol,
  SetCheckoutOption,
  SetCheckoutOptionIsSymbol,
  SuggestionResult,
  SuggestionResultIsSymbol,
  VisitPage,
  VisitPageIsSymbol,
  decodeEvent,
  decodeSingleConstructorAr1,
  encodeEvent,
  eqEvent,
  genericDecodeArgsArgument,
  genericEncodeArgsArgument,
  genericEvent,
  showEvent,
  toFillFormTypeEvent,
  unscrambleDecodeEvent
};
